import React from 'react';
import { formatDistanceToNow } from 'date-fns';

interface ProviderStatusCardProps {
  provider: string;
  isValid?: boolean;
  lastCheckedAt: string | null;
  apiKeyHint: string | null;
  isLoading?: boolean;
}

export const ProviderStatusCard: React.FC<ProviderStatusCardProps> = ({
  provider,
  isValid,
  lastCheckedAt,
  apiKeyHint,
  isLoading,
}) => {
  const label = provider === 'openai' ? 'OpenAI' : 'AssemblyAI';
  const checkedAgo = lastCheckedAt
    ? formatDistanceToNow(new Date(lastCheckedAt), { addSuffix: true })
    : 'never';

  if (isLoading) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-5 shadow-sm animate-pulse">
        <div className="flex items-center justify-between mb-3">
          <div className="h-4 bg-gray-200 rounded w-24" />
          <div className="h-5 bg-gray-200 rounded-full w-16" />
        </div>
        <div className="space-y-1">
          <div className="h-3 bg-gray-100 rounded w-20" />
          <div className="h-3 bg-gray-100 rounded w-28" />
        </div>
      </div>
    );
  }

  const healthy = isValid !== false;

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-5 shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-gray-700">{label} Status</h3>
        <span
          className={`inline-flex items-center gap-1.5 text-xs font-medium px-2 py-0.5 rounded-full ${
            healthy
              ? 'bg-green-50 text-green-700'
              : 'bg-red-50 text-red-700'
          }`}
        >
          <span
            className={`w-2 h-2 rounded-full ${
              healthy ? 'bg-green-500' : 'bg-red-500'
            }`}
          />
          {healthy ? 'Healthy' : 'Error'}
        </span>
      </div>
      <div className="text-xs text-gray-500 space-y-1">
        {apiKeyHint && (
          <p>
            Key: <span className="font-mono text-gray-600">...{apiKeyHint}</span>
          </p>
        )}
        <p>Checked {checkedAgo}</p>
      </div>
    </div>
  );
};
